export default () => {
  document.querySelectorAll(".js-breadcrumb").forEach((el) => {
    // check if secondary nav exists on the pages
    // it also exists within the breadcrumb so check for multiples
    if (document.querySelectorAll(".js-secondary-nav").length > 1) {
      el.classList.add("breadcrumb--show-nav");
    }
  });
};
